
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 确保页面能正常加载
try {
  // 立即显示加载动效，避免白屏
  document.body.style.margin = '0';
  document.body.style.padding = '0';
  document.body.style.backgroundColor = '#8B4513';
  document.body.style.background = 'linear-gradient(135deg, #8B4513 0%, #A0522D 50%, #CD853F 100%)';

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  // 添加全局错误处理
  window.addEventListener('error', (event) => {
    // 静默处理某些无关紧要的错误
    if (event.error === null || event.message.includes('Script error')) {
      event.preventDefault();
      return;
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    // 静默处理Promise错误
    event.preventDefault();
  });

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} catch (error) {
  console.error('应用启动失败:', error);
  // 显示错误信息
  document.body.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; height: 100vh; background: #8B4513; color: white; font-family: Arial, sans-serif;">
      <div style="text-align: center;">
        <h1>页面加载中...</h1>
        <p>如果页面长时间未响应，请刷新重试</p>
      </div>
    </div>
  `;
}
